module.exports = __webpack_public_path__ + "static/media/work-02-small.254b2b99.jpg";